import { render, staticRenderFns } from "./StateLabel.vue?vue&type=template&id=bdbeb282&"
import script from "./StateLabel.vue?vue&type=script&lang=ts&"
export * from "./StateLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports